import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    boxSizing: "border-box",
    alignItems: "center",
    background: theme.colors.Background4,
    width: 343,
    borderRadius: theme.radius.small,
    padding: theme.spacing.space16,
    zIndex: theme.zIndex.dialog + 1,
    justifyContent: "space-between",
    opacity: 0,
    top: -theme.spacing.space32,
    boxShadow:
      "0px 4px 4px 0px rgba(0, 0, 0, 0.30), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)",
    position: "fixed",
    left: "50%",
    transform: "translate(-50%)",
  },
  icon: {
    color: theme.colors.TextDefault,
    cursor: "pointer",
  },
  content: {
    flex: 1,
  },
  hide: {
    animation: "$fadeOut 0.3s ease-in both",
  },
  show: {
    animation: "$fadeIn 0.3s ease-in both",
  },
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      top: -theme.spacing.space32,
    },
    to: {
      opacity: 1,
      top: theme.spacing.space32,
    },
  },
  "@keyframes fadeOut": {
    from: {
      opacity: 1,
      top: theme.spacing.space32,
    },
    to: {
      pointerEvents: "none",
      display: "none",
      opacity: 0,
      top: -theme.spacing.space32,
    },
  },
}));
